<template>
  <div id="system-manage-email-email-signature">
    <div class="action-table">
      <ipub-table :columns="columns"
                  :pagination="false"
                  :dataSource="dataSource">
        <template v-slot:emailSignature="{text}">
          <div v-html="text"></div>
        </template>
        <template v-slot:actions="{record}">
          <ipub-tooltip placement="bottomRight">
            <div slot="title">Set Signature</div>
            <ipub-icon type="iconEdit"
                       @click="signature(record)" />

          </ipub-tooltip>
        </template>
      </ipub-table>
    </div>
    <signature-model :isVisable="isVisable"
                     @cancel="cancel"
                     @list="getList"
                     :info="info"></signature-model>
    <!--                      :info="info" -->
  </div>
</template>

<style lang="scss" scoped>
@import './main.scss';
</style>

<script>
import main from './main'
export default main
</script>
